export const getWbsName = (list: any, wbsID: any): string => {
  if (list && wbsID in list) {
    return list[wbsID]
  }
  return ''
}
